import type { ChangeEvent, ReactElement } from 'react';
import { GraphToolbarButton, GRAPH_TOOLBAR_SLIDER_STYLE } from '../Cmarkdowngraphcontrols';
import { DEPTH_COLORS, MAX_ZOOM, MIN_ZOOM } from './treemap-constants';
const ZOOM_SLIDER_STEP = 0.01;
interface TreemapControlsProps {
    isMinimapVisible: boolean;
    isReady: boolean;
    zoomLevel: number;
    onZoomIn: () => void;
    onZoomOut: () => void;
    onZoomSliderChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onResetView: () => void;
    onToggleMinimap: () => void;
}
export function TreemapControls({ isMinimapVisible, isReady, zoomLevel, onZoomIn, onZoomOut, onZoomSliderChange, onResetView, onToggleMinimap, }: TreemapControlsProps): ReactElement {
    return (
      <>
      <GraphToolbarButton onClick={onZoomIn} disabled={!isReady} label="Zoom in">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M7 3.4V10.6M3.4 7H10.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
        </svg>
      </GraphToolbarButton>
      <GraphToolbarButton onClick={onZoomOut} disabled={!isReady} label="Zoom out">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M3.4 7H10.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
        </svg>
      </GraphToolbarButton>
      <input type="range" min={MIN_ZOOM} max={MAX_ZOOM} step={ZOOM_SLIDER_STEP} value={zoomLevel} onChange={onZoomSliderChange} aria-label="Zoom level" disabled={!isReady} style={{
            ...GRAPH_TOOLBAR_SLIDER_STYLE,
            accentColor: DEPTH_COLORS[0],
            opacity: isReady ? 1 : 0.45,
        }}/>
      <GraphToolbarButton onClick={onResetView} disabled={!isReady} label="Fit treemap">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M5 1.5H1.5V5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 1.5H12.5V5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 12.5H1.5V9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 12.5H12.5V9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </GraphToolbarButton>
      <GraphToolbarButton onClick={onToggleMinimap} disabled={false} label={isMinimapVisible ? 'Hide minimap' : 'Show minimap'}>
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M1.5 3.2L4.8 1.8L9.2 3.2L12.5 1.8V10.8L9.2 12.2L4.8 10.8L1.5 12.2V3.2Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round"/>
          <path d="M4.8 1.8V10.8" stroke="currentColor" strokeWidth="1.1"/>
          <path d="M9.2 3.2V12.2" stroke="currentColor" strokeWidth="1.1"/>
        </svg>
      </GraphToolbarButton>
      </>
    );
}
